import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import { useCallback } from "react";
import { useDevice } from "../../../providers/DeviceProvider";

const useStyles = makeStyles()(
  (theme) => ({
    root: {
      padding: theme.spacing(2),
      width: "100%",
      boxShadow: "none",
      background: theme.palette.background.grey,
      borderRadius: `${theme.spacing(2)} !important`,
      "& .MuiAccordionDetails-root": {
        padding: 0,
      },
      "& .MuiAccordionSummary-root": {
        padding: 0,
      },
      "& .MuiAccordionSummary-content": {
        margin: 0,
      }
    },
    isMobilePortraitView: {
      padding: theme.spacing(1.5)
    },
    actions: {
      position: "relative",
      width: "100%",
      height: "auto",
    }
  })
);

export default function DynamicAccordion(props) {
  const { defaultExpanded, title, expanded, onExpand } = props;
  const { classes } = useStyles();
  const { isMobilePortraitView } = useDevice();

  const onHandleExpand = useCallback((_, v) => {
    onExpand(v);
  }, [onExpand])

  return (
    <Accordion defaultExpanded={defaultExpanded} className={`${classes.root} ${isMobilePortraitView ? classes.isMobilePortraitView : ""}`} disableGutters expanded={expanded} onChange={typeof onExpand === "function" ? onHandleExpand : undefined}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
      >
        <Typography variant="subtitle1">{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        {props.children}
      </AccordionDetails>
    </Accordion>
  );
}